import { render, staticRenderFns } from "./NotificationConversationStarted.vue?vue&type=template&id=1e757fe4&"
import script from "./NotificationConversationStarted.vue?vue&type=script&lang=js&"
export * from "./NotificationConversationStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports